import LineChart from './LineChart'

export default function AreaChart(props) {
  return <LineChart {...props} areaChart />
}
